import ApiService from 'src/shared/utils/base-api/api-service';
import {PaginationParamsDto} from '../common-dtos/pagination-params-dto';
import {
  ProductRejectionReasonsDto,
  ProductRejectionReasonsObjDto,
} from './dto/product-rejection-reasons-dto';
import {
  CreateOrUpdateReasonsDto,
  ResponseCreateOrUpdateReasonsDto,
} from './dto/create-or-update-reasons-dto';
import {
  AddNewReasonDescriptionDto,
  ResponseAddNewReasonDescriptionDto,
} from './dto/add-new-reason-description-dto';
import {GetAllReasonDescriptionsParamsDto} from './dto/get-all-reason-descriptions-params-dto';
import {GetAllReasonDescriptionsListObjDto} from './dto/get-all-reason-descriptions-list-dto';

class ProductRejectionReasonsService extends ApiService {
  constructor() {
    super({
      baseURL: '/AdminRejectionReason',
    });
  }

  getproductRejectionReasons(
    input?: PaginationParamsDto,
  ): Promise<ProductRejectionReasonsObjDto> {
    return this.get('/GetAllRejectionReasons', {
      params: input,
    });
  }

  getRejectionReasonById(
    rejectionReasonById?: string,
  ): Promise<ProductRejectionReasonsDto> {
    return this.get('/GetRejectionReasonById', {
      params: {
        id: rejectionReasonById,
      },
    });
  }
  addNewRejectionReason(
    input: CreateOrUpdateReasonsDto,
  ): Promise<ResponseCreateOrUpdateReasonsDto> {
    return this.post('/AddNewRejectionReason', input);
  }
  updateRejectionReason(id: string, input: CreateOrUpdateReasonsDto) {
    return this.put('/UpdateRejectionReason', input, {
      params: {
        id: id,
      },
    });
  }

  changeRejectionReasonStatus(id: string) {
    return this.put('/ToggleActiveRejectionReason', null, {
      params: {
        id: id,
      },
    });
  }

  deleteRejectionReason(id: string) {
    return this.delete('/DeleteRejectionReason', {
      params: {
        id: id,
      },
    });
  }

  getAllRejectionReasonDescriptions(
    input: GetAllReasonDescriptionsParamsDto,
  ): Promise<GetAllReasonDescriptionsListObjDto> {
    return this.get('/GetAllRejectionReasonDescriptions', {
      params: input,
    });
  }

  addNewRejectionReasonDescription(
    input: AddNewReasonDescriptionDto,
  ): Promise<ResponseAddNewReasonDescriptionDto> {
    return this.post('/AddNewRejectionReasonDescription', input);
  }

  updateRejectionReasonDescription(
    optionId: string,
    input: AddNewReasonDescriptionDto,
  ) {
    return this.put('/UpdateRejectionReasonDescription', input, {
      params: {
        id: optionId,
      },
    });
  }

  deleteRejectionReasonDescription(optionId: string) {
    return this.delete('/DeleteRejectionReasonDescription', {
      params: {
        id: optionId,
      },
    });
  }
}

export const productRejectionReasonsService =
  new ProductRejectionReasonsService();
